import React from "react";

const HeroCard = () => {
  return <div>HeroCard</div>;
};

export default HeroCard;
